const AppColors = {
  ModalColor:'rgba(66, 31, 0, 0.5)',
  BLUR_BG: 'rgba(0,0,0,0.50)',
  white: '#FFFFFF',
  black: '000000',
  lightpink: '#FEF9FB40',
  purple: '#79266A1A',
  white1: "#EDDFE1",
  white2: "rgb(252,250,236)",
  sandal: '#F6EFE9',
  brown: '#9C4900',
  brown1: '#8F4300',
  brown2: '#8F430080',
  darkbrown: '#421F00',
  red: '#FF0000',
  green: '#04B54C',
  dualbrown: '#8F430080',
  C4900CC: '#9C4900CC',
  '#9C490080': '#9C490080',
  FeedBack: '#766C8E',
  grey: '#ACACAC80',
  grey1: '#ACACAC',
  blue: '#0000FF',
  lightgreen:'#02C0380D',
  lightRed:'#FF00000D',
  lightyellow:"#F6A3000D",
  Black:'#111111',
  
}

export default AppColors
